export const routes = [
  "/",
  "/live",
  "/live/c/:canvasId",
  "/live/table",
  "/analysis",
  "/analysis/s/:savedId",
  "/posture",
  "/posture/inputs",
  "/posture/inputs/:inputId",
  "/posture/targets",
  "/devices",
  "/devices/:deviceId",
  "/devices/:deviceId/health",
  "/devices/install",
  "/alerts",
  "/alerts/:alertId",
  "/alerts/rules",
  "/alerts/rules/new",
  "/alerts/rules/:ruleId",
  "/reports",
  "/reports/new",
  "/reports/:reportId",
  "/reports/schedules",
  "/privacy",
  "/privacy/receipts",
  "/privacy/receipts/:receiptId",
  "/privacy/schema",
  "/privacy/retention",
  "/privacy/export",
  "/privacy/delete",
  "/privacy/requests",
  "/org",
  "/org/members",
  "/org/members/:userId",
  "/org/invites",
  "/org/teams",
  "/org/teams/:teamId",
  "/org/roles",
  "/org/sso",
  "/org/scim",
  "/org/residency",
  "/org/keys",
  "/org/partners",
  "/org/evidence",
  "/audit",
  "/audit/:eventId",
  "/integrations",
  "/integrations/new",
  "/integrations/:integrationId",
  "/developer",
  "/developer/credentials",
  "/developer/clients",
  "/developer/usage",
  "/billing",
  "/billing/invoices",
  "/billing/invoices/:invoiceId",
  "/billing/seats",
  "/billing/usage",
  "/settings/account",
  "/settings/security",
  "/settings/devices",
  "/settings/privacy",
  "/settings/notifications",
  "/settings/appearance",
  "/assistant",
  "/search",
  "/404",
  "/403",
  "/402",
  "/500",
  "/503",
  "/signin/enroll",
  "/signup/recovery",
  "/signin",
  "/signin/2fa",
  "/signin/recovery",
  "/signup",
  "/verify-email",
  "/reset-password",
  "/accept-invite/:token",
  "/sso/:orgSlug",
  "/signout",
  "/session-expired",
  "/region-moved"
] as const;
